import { franc, francAll } from 'franc-cjs';
import { logWarn } from '../utilities/logger';

const KNOWN_LANG_PROBABILITY_THRESHOLD = 0.995;
const UNKNOWN_LANGUAGE = 'unknown';
const KNOWN_LANGUAGES = {
	en: 'eng',
	es: 'spa',
	it: 'ita',
	fr: 'fra',
	pt: 'por',
	zh: 'cmn',
	sv: 'swe',
	de: 'deu',
	no: 'nob',
};

export const extractContent = (content: unknown, ignoreProperties: string[] = []): string => {
	if (content === null || content === undefined) {
		return '';
	}
	if (typeof content === 'string') {
		return content;
	}
	if (Array.isArray(content)) {
		return content
			.map((item) => extractContent(item, ignoreProperties))
			.filter((val) => !!val)
			.join('. ');
	}
	return Object.entries(content)
		.map(([key, value]) => (ignoreProperties.includes(key) ? '' : extractContent(value, ignoreProperties)))
		.filter((val) => !!val)
		.join('. ');
};

export const getContentLang = (content: string): string => {
	return content ? franc(content, { only: Object.values(KNOWN_LANGUAGES) }) : UNKNOWN_LANGUAGE;
};

export const convertFromLocale = (language: string): string => {
	let matchLanguage = language;
	if (language.includes('-')) {
		matchLanguage = language.split('-')[0];
	}
	return KNOWN_LANGUAGES[matchLanguage] ?? language;
};

export const validateLanguage = (language: string, content: string, logId?: string): boolean => {
	const expected = convertFromLocale(language);
	const lang = francAll(content, { only: Object.values(KNOWN_LANGUAGES) });
	const match = lang.find((item) => item[0] === expected && item[1] >= KNOWN_LANG_PROBABILITY_THRESHOLD);
	if (!match) {
		// language exceptions to prevent false/positives. Looks for a words that hints that language is actually correct
		if (
			(expected === KNOWN_LANGUAGES.sv && content.includes('Australien och Nya Zeeland')) ||
			(expected === KNOWN_LANGUAGES.de && content.includes('Australien und Neuseeland')) ||
			(expected === KNOWN_LANGUAGES.no && content.includes('Australia og New Zealand')) ||
			(expected === KNOWN_LANGUAGES.zh && content.includes('立即預訂'))
		) {
			return true;
		}

		logWarn('Content language do not match', { expected, logId, content, lang });
		return false;
	}
	return true;
};
